<template>
  <b-container fluid>
    <b-row v-if="!isLoading" class="justify-content-center">
      <b-col lg="8">
        <!-- breadcrumb -->
        <BaseBreadCrumb :items="breadcrumbs" />

        <!-- Learning unit name -->
        <div class="display-4 font-weight-bold">
          {{ learningUnit.name }}
        </div>

        <!-- title -->
        <div class="h5 font-weight-bold mt-u6">Create overall passing criteria</div>

        <!-- form -->
        <LearningUnitScoreDescriptionForm
          class="mt-u8"
          :is-saving="isSaving"
          :data="data"
          @save="save"
          @cancel="goToPreviousPage"
        />
      </b-col>
    </b-row>
    <div v-else class="d-flex justify-content-center">
      <b-spinner label="Loading..." variant="dark" />
    </div>
  </b-container>
</template>

<script>
import BaseBreadCrumb from '@/components/base-components/BaseBreadCrumb';
import LearningUnit from '@/models/LearningUnit';
import LearningUnitScoreDescriptionForm from '@/components/LearningUnit/LearningUnitScoreDescriptionForm.vue';

export default {
  components: {
    BaseBreadCrumb,
    LearningUnitScoreDescriptionForm
  },

  data() {
    return {
      isLoading: true,
      isSaving: false,
      data: {
        score_description: ''
      }
    };
  },

  computed: {
    learningUnitId() {
      return this.$route.params.learningUnitId;
    },

    learningUnit() {
      return LearningUnit.find(this.learningUnitId);
    },

    breadcrumbs() {
      return [
        {
          key: 'user-dashboard',
          name: 'User Dashboard',
          to: {
            name: 'user-dashboard'
          }
        },
        {
          key: 'design-planning-info',
          name: this.learningUnit.name,
          to: {
            name: 'design-planning/info',
            params: {
              learningUnitId: this.learningUnitId
            },
            query: {
              tab: 'evaluation-assessments'
            }
          }
        },
        {
          key: 'score-description',
          name: 'Score Description',
          active: true
        }
      ];
    }
  },

  created() {
    this.init();
  },

  methods: {
    async init() {
      this.isLoading = true;

      /* fetch learning unit */
      if (!this.learningUnit) {
        await LearningUnit.api().fetchByLearningUnitId(this.learningUnitId);
      }
      this.data.score_description = this.learningUnit.score_description;

      this.isLoading = false;
    },

    async save(data) {
      this.isSaving = true;
      await LearningUnit.api().updateLearningUnit(this.learningUnitId, data);
      this.isSaving = false;
      this.goToPreviousPage();
    },

    goToPreviousPage() {
      if (this.$route.query.previousPath) {
        const { previousPath } = this.$route.query;
        this.$router.push({ path: previousPath });
      } else {
        this.$router.push({
          name: 'design-planning/info',
          params: {
            learningUnitId: this.learningUnitId
          },
          query: {
            tab: 'evaluation-assessments'
          }
        });
      }
    }
  }
};
</script>
